/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePalReauthCaseManagerRequest
 */
export interface CreatePalReauthCaseManagerRequest {
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    phone?: string | null;
    /**
     * 
     */
    fax?: string | null;
    /**
     * 
     */
    email?: string | null;
}

/**
 * Check if a given object implements the CreatePalReauthCaseManagerRequest interface.
 */
export function instanceOfCreatePalReauthCaseManagerRequest(value: object): value is CreatePalReauthCaseManagerRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreatePalReauthCaseManagerRequestFromJSON(json: any): CreatePalReauthCaseManagerRequest {
    return CreatePalReauthCaseManagerRequestFromJSONTyped(json, false);
}

export function CreatePalReauthCaseManagerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePalReauthCaseManagerRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'phone': json['phone'] === undefined ? undefined : json['phone'] === null ? null : json['phone'],
        'fax': json['fax'] === undefined ? undefined : json['fax'] === null ? null : json['fax'],
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
    };
}

export function CreatePalReauthCaseManagerRequestToJSON(json: any): CreatePalReauthCaseManagerRequest {
    return CreatePalReauthCaseManagerRequestToJSONTyped(json, false);
}

export function CreatePalReauthCaseManagerRequestToJSONTyped(value?: CreatePalReauthCaseManagerRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'phone': value['phone'],
        'fax': value['fax'],
        'email': value['email'],
    };
}

